import { render, staticRenderFns } from "./VideoTitle.vue?vue&type=template&id=615a2735&scoped=true"
import script from "./VideoTitle.vue?vue&type=script&lang=js"
export * from "./VideoTitle.vue?vue&type=script&lang=js"
import style0 from "./VideoTitle.vue?vue&type=style&index=0&id=615a2735&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a2735",
  null
  
)

export default component.exports